import { Pipe, PipeTransform } from '@angular/core';
import * as marked from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'markdown' })
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(markdown: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(marked(markdown));
  }

}
